import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { createTheme } from '@mui/material/styles';
import SignatureCanvas from 'react-signature-canvas';
import Typography from '@mui/material/Typography';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
  signatureLabel: {
    marginBottom: '8px',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  signatureContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  signatureInstructions: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: theme.palette.text.disabled,
    pointerEvents: 'none',
    fontSize: '14px',
    fontStyle: 'italic',
  },
});

class ESignature extends React.Component {
  constructor(props) {
    super(props);
    this.sigCanvas = React.createRef();
  }

  render() {
    const { classes } = this.props;
    try {
      return (
        <div className={classes.root}>
          <div className={classes.signatureContainer}>
            <SignatureCanvas
              ref={this.sigCanvas}
              penColor="black"
              canvasProps={{
                width: 400,
                height: 150,
                style: {
                  borderColor: 'var(--mui-palette-text-secondary)',
                  borderStyle: 'solid',
                  borderWidth: '1px',
                  width: '100%',
                  borderRadius: '8px',
                  backgroundColor: 'var(--mui-palette-action-hover)',
                },
              }}
            />
            <Typography className={classes.signatureInstructions}>Sign here</Typography>
          </div>
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

ESignature.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ESignature);
